import FrasesListLayer from "../../components/FrasesListLayer";

const FrasesPage = () => {
  return <FrasesListLayer />;
};

export default FrasesPage;
